export default __webpack_public_path__ + "static/media/terminate.5ab277ad.svg";